var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// shadcn Card ported to our conventions (named exports, `cn` helper, redesign `card` tokens).
export const Card = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div ref={ref} className={cn('rounded-lg border border-solid bg-card text-card-foreground shadow-sm', className)} {...props}/>);
});
Card.displayName = 'Card';
export const CardHeader = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props}/>);
});
CardHeader.displayName = 'CardHeader';
export const CardTitle = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div ref={ref} className={cn('font-display text-2xl font-semibold leading-none tracking-tight', className)} {...props}/>);
});
CardTitle.displayName = 'CardTitle';
export const CardDescription = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props}/>);
});
CardDescription.displayName = 'CardDescription';
export const CardContent = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div ref={ref} className={cn('p-6 pt-0', className)} {...props}/>);
});
CardContent.displayName = 'CardContent';
export const CardFooter = forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props}/>);
});
CardFooter.displayName = 'CardFooter';
